export enum TYPO_SIZE {
  H1 = 'h1',
  H2 = 'h2',
  H3 = 'h3',
  BODY_LARGE = 'body-large',
  BODY = 'body',
  BODY_SMALL = 'body-small',
  CAPTION = 'caption',
}

export enum FONT_WEIGHT {
  REGULAR = 400,
  MEDIUM = 500,
  SEMIBOLD = 600,
  BOLD = 700,
}

export enum POSITION {
  LEFT = 'left',
  RIGHT = 'right',
}

export enum USER_TYPES {
  ADMIN = 'admin',
  PROFESSOR = 'professor',
  STUDENT = 'student',
}
